"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language = exports.MobileOS = exports.CommonError = void 0;
exports.CommonError = {
    // Service Logic Error
    InvalidInput: "INPUT_INVALID",
    ItemNotFound: "ERR_ITEM_NOT_FOUND",
    InternalUnknown: "INTERNAL_UNKNOWN",
    // Networking Error
    FailToFetch: "FAIL_TO_FETCH",
    RequestTimeout: "REQUEST_TIMEOUT",
    Undefined: "UNDEFINED"
};
exports.MobileOS = {
    IOS: "iOS",
    Android: "Android",
    Windows: "Windows Phone"
};
exports.Language = {
    TH: "th",
    EN: "en"
};
